/* eslint-disable */
/** #10 — Fragrance pyramid (Top / Heart / Base notes) as styled SVG. */
export default function FragrancePyramid({ top = [], heart = [], base = [] }) {
  if (!top.length && !heart.length && !base.length) return null;

  const Layer = ({ label, color, items, indent }) => (
    <div className="text-center" style={{ paddingLeft: `${indent}%`, paddingRight: `${indent}%` }} data-testid={`pyramid-${label.toLowerCase()}`}>
      <div
        className="px-4 py-3 border"
        style={{
          background: `linear-gradient(180deg, ${color}1F 0%, transparent 100%)`,
          borderColor: `${color}55`,
        }}
      >
        <p className="text-[10px] uppercase tracking-[0.3em] font-sans font-medium" style={{ color }}>{label}</p>
        <p className="text-white/85 text-sm sm:text-base font-sans mt-1.5 leading-snug">
          {items.length ? items.join(' · ') : <span className="text-white/30 italic">—</span>}
        </p>
      </div>
    </div>
  );

  return (
    <div className="space-y-2" data-testid="fragrance-pyramid">
      <Layer label="Top notes" color="#F3E5AB" items={top} indent={20} />
      <Layer label="Heart notes" color="#D4AF37" items={heart} indent={10} />
      <Layer label="Base notes" color="#1C7D3F" items={base} indent={0} />
      <p className="text-center text-white/30 text-[10px] font-sans uppercase tracking-[0.2em] mt-2">
        First impression → Develops → Lasts on skin
      </p>
    </div>
  );
}
